










































































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import { filter, cloneDeep } from 'lodash';
import {
  Partner, PartnersApi, PartnerSchedule,
} from '@compassdigital/foodworks.ts.sdk';
import ScheduleSettingPartnersEdit
  from '@/components/Form/Partner/ScheduleSettingsPartners/ScheduleSettingPartnersEdit/index.vue';
import SystemModule from '@/store/modules/system';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import AppModule from '@/store/modules/app';
import ScheduleUtil from '@/util/ScheduleUtil';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    ScheduleSettingPartnersEdit,
    EditConfirmation,
  },
})
export default class ScheduleSettingsPartner extends Vue {
  @PropSync('partnerInformation', {}) partnerInfoLocal!: any;

  @Prop({}) status!: string;

  public edit: boolean = false;

  public saving: boolean = false;

  public cachedUser: any = {};

  public checkArray: any = {
    emptyArray: false,
    defaultArray: false,
    fiveDayArray: false,
  };

  public get availabeDaysPattern() {
    const restInfo = cloneDeep(this.partnerInfoLocal);
    this.cachedUser = restInfo;
    if (this.partnerInfoLocal.schedule) {
      const { popupPattern } = this.partnerInfoLocal.schedule;
      if (popupPattern.length > 0) {
        const newPattern = ScheduleUtil.schedulePatternCheck(popupPattern);
        const updateArray = this.uniqBy(newPattern, JSON.stringify);
        const calendarChronologyArray = updateArray[0];
        const newCheckArray = ScheduleUtil.sortArrayCalendarFormat(calendarChronologyArray);
        const allDaysArray = [
          'Friday', 'Tuesday', 'Wednesday', 'Thursday', 'Monday', 'Sunday', 'Saturday',
        ];

        const fiveDayArray = [
          'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday',
        ];

        if (newCheckArray !== undefined) {
          const isEqual = (allDaysArray.length === newCheckArray.length)
          && (allDaysArray.every(val => newCheckArray.includes(val)));

          const isFiveDayArray = (fiveDayArray.length === newCheckArray.length)
          && (fiveDayArray.every(val => newCheckArray.includes(val)));

          if (newCheckArray !== undefined && isEqual === true && isFiveDayArray === false) {
            this.checkArray.defaultArray = true;
            this.checkArray.emptyArray = false;
            this.checkArray.fiveDayArray = false;
            return '';
          }
          if (newCheckArray !== undefined && isEqual === false && isFiveDayArray === false) {
            this.checkArray.defaultArray = false;
            this.checkArray.emptyArray = false;
            this.checkArray.fiveDayArray = false;
            return newCheckArray;
          }
          if (newCheckArray !== undefined && isFiveDayArray === true && isEqual === false) {
            this.checkArray.defaultArray = false;
            this.checkArray.emptyArray = false;
            this.checkArray.fiveDayArray = true;
            return '';
          }
        }

        if (newCheckArray === undefined) {
          this.checkArray.emptyArray = true;
          this.checkArray.defaultArray = false;
          this.checkArray.fiveDayArray = false;
          return '';
        }
      }
    }
    return '';
  }

  public onCancel() {
    this.edit = false;
    this.partnerInfoLocal = this.cachedUser;
  }

  public uniqBy(updateNewArray: any, key: any) {
    const seen = {};
    // eslint-disable-next-line
    return updateNewArray.filter(function(item: any) {
      const k = key(item);
      // eslint-disable-next-line
      const filteredArray = seen.hasOwnProperty(k) ? false : (seen[k] = true);
      return filteredArray;
    });
  }

  public async onSave() {
    if (
      (this.$refs.form as any).validate()
      && this.partnerInfoLocal !== null
    ) {
      this.saving = true;
      try {
        try {
          const schedule = {
            id: this.partnerInfoLocal.id,
            schedule: this.partnerInfoLocal.schedule,
          };
          const api = new PartnersApi(AppModule.apiConfig);
          const data = await api.patchPartnerById(
            this.partnerInfoLocal.id, schedule,
          );
        } catch (error) {
          console.log('error', error);
        }
        this.edit = false;
      } catch (e) {
        //
      }
      this.saving = false;
    }
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
